import { render, staticRenderFns } from "./ModalFinishService.vue?vue&type=template&id=2070d875"
import script from "./ModalFinishService.vue?vue&type=script&lang=js"
export * from "./ModalFinishService.vue?vue&type=script&lang=js"
import style0 from "./ModalFinishService.vue?vue&type=style&index=0&id=2070d875&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2070d875')) {
      api.createRecord('2070d875', component.options)
    } else {
      api.reload('2070d875', component.options)
    }
    module.hot.accept("./ModalFinishService.vue?vue&type=template&id=2070d875", function () {
      api.rerender('2070d875', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/services/components/ModalFinishService.vue"
export default component.exports